import { z } from 'zod';
import { BackgroundSchema, ImageSizeSchema, ModelProviderSchema, OpenAiQualitySchema, OpenRouterImageSizeSchema, PipelineTypeSchema, PresetIdSchema, ProviderApiFormatSchema, } from './generation.js';
export const PresetConditionalSegmentsSchema = z.strictObject({
    supports_style_authority: z.boolean(),
    supports_style_enhancement: z.boolean(),
    supports_photo_language: z.boolean(),
    supports_brand_context: z.boolean(),
    supports_text_rendering_boost: z.boolean(),
    anti_ai_without_references: z.boolean(),
});
export const PublicPresetInfoSchema = z.strictObject({
    id: PresetIdSchema,
    name: z.string().trim().min(1),
    pipeline: PipelineTypeSchema,
    word_budget: z.number().int().positive(),
    conditional_segments: PresetConditionalSegmentsSchema,
});
export const PresetQualityParamsSchema = z.strictObject({
    quality: OpenAiQualitySchema.optional(),
    openrouter_image_size: OpenRouterImageSizeSchema.optional(),
    input_fidelity: z.enum(['low', 'high']).optional(),
});
export const PresetQualityMapSchema = z.strictObject({
    low: PresetQualityParamsSchema.optional(),
    medium: PresetQualityParamsSchema.optional(),
    high: PresetQualityParamsSchema.optional(),
});
export const PresetModelRouteSchema = z.strictObject({
    provider: ModelProviderSchema,
    model_id: z.string().trim().min(1),
    api_format: ProviderApiFormatSchema,
});
export const PresetModelRoutingSchema = z.strictObject({
    primary: PresetModelRouteSchema,
    refinement: PresetModelRouteSchema.optional(),
});
export const PresetProfileSchema = z.strictObject({
    id: PresetIdSchema,
    name: z.string().trim().min(1),
    pipeline: PipelineTypeSchema,
    word_budget: z.number().int().positive(),
    conditional_segments: PresetConditionalSegmentsSchema,
    model_routing: PresetModelRoutingSchema,
    quality_map: PresetQualityMapSchema,
    default_size: ImageSizeSchema,
    default_output_format: z.enum(['png', 'jpeg', 'webp']),
    default_background: BackgroundSchema,
});
export const PresetCatalogSchema = z.record(PresetIdSchema, PublicPresetInfoSchema);
export const PresetProfileCatalogSchema = z.record(PresetIdSchema, PresetProfileSchema);
// Keep old schema name exported for gradual migration — will be removed in a follow-up
/** @deprecated token_cost is no longer part of preset definitions. */
export const PresetTokenCostSchema = z.strictObject({
    draft: z.number().int().nonnegative(),
    production: z.number().int().nonnegative(),
});
//# sourceMappingURL=preset.js.map